export var COMMAND_ACCOUNT_FLAG_GET = 'wh.common.command.account.flags.state.get';
export var EVENT_ACCOUNT_FLAG_GET = 'wh.common.event.account.flags.state.get';

export var softFlagRequested = {
  topic: 'wh.common.command.account.action.execute',
  data: {
    eventId: 'event.account.flag.trigger.start.requested',
    context: {
      data: {
        type: 'S',
        flag: 'JUMIO_POPUP_SHOW',
        event: 'POST_DEFAULT'
      },
      userFlow: 'account-flags'
    }
  }
};

export var apiCallInvalid = {
  topic: 'wh.common.command.account.action.execute',
  data: {
    eventId: 'event.account.api.call.invalid',
    context: {
      data: {
        query: 'AccountFlagsStatusFlagsQuery'
      }
    }
  }
};